import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { router } from './router';
import { resolvePublicApiBase } from './lib/publicApiBase';
import { initBranding } from './stores/branding';
import { initTheme } from './stores/theme';
import './styles.css';

// Apply stored theme + brand palette to <html> before first paint.
initTheme();
initBranding();
document.documentElement.dataset.trailmarkApiBase = resolvePublicApiBase();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <div className="flex h-full min-h-0 flex-col">
        <RouterProvider router={router} />
      </div>
      <Toaster position="bottom-right" richColors />
    </QueryClientProvider>
  </StrictMode>,
);
